import { render } from "./Sheet.vue?vue&type=template&id=357ba437&scoped=true&ts=true"
import script from "./Sheet.vue?vue&type=script&lang=ts"
export * from "./Sheet.vue?vue&type=script&lang=ts"

import "./sheet.scss?vue&type=style&index=0&id=357ba437&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357ba437"]])

export default __exports__